import React, { useState } from 'react';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../firebase';
import { Link, useNavigate } from 'react-router-dom';
import { FiEye, FiEyeOff } from 'react-icons/fi'; // 👁️ Modern szürke ikonok

const LoginForm = ({ onClose }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await signInWithEmailAndPassword(auth, email, password);
      console.log('✅ Sikeres bejelentkezés');
      setIsLoggedIn(true);
      setTimeout(() => {
        if (onClose) onClose();
        navigate('/profil');
      }, 1500);
    } catch (err) {
      console.error('❌ Hiba a bejelentkezéskor:', err.message);
      switch (err.code) {
        case 'auth/user-not-found':
        case 'auth/wrong-password':
          setError('Hibás email vagy jelszó');
          break;
        case 'auth/invalid-email':
          setError('Érvénytelen email cím');
          break;
        default:
          setError('Ismeretlen hiba történt');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        position: 'absolute',
        top: '70px',
        right: '20px',
        backgroundColor: '#fff',
        padding: '1.5rem',
        borderRadius: '8px',
        boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
        zIndex: 1000,
        width: '300px',
        fontFamily: 'Arial, sans-serif',
        boxSizing: 'border-box'
      }}
    >
      <h3 style={{ marginBottom: '1rem', color: '#b30000', textAlign: 'center' }}>
        Bejelentkezés
      </h3>

      <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          style={{
            padding: '0.5rem',
            fontSize: '1rem',
            borderRadius: '4px',
            border: '1px solid #ccc',
            boxSizing: 'border-box'
          }}
        />

        <div
          style={{
            position: 'relative',
            maxWidth: '100%',
            overflow: 'hidden',
            boxSizing: 'border-box'
          }}
        >
          <input
            type={showPassword ? 'text' : 'password'}
            placeholder="Jelszó"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            style={{
              padding: '0.5rem',
              fontSize: '1rem',
              borderRadius: '4px',
              border: '1px solid #ccc',
              width: '100%',
              paddingRight: '2.5rem',
              boxSizing: 'border-box'
            }}
          />
          <button
            type="button"
            onClick={() => setShowPassword(!showPassword)}
            style={{
              position: 'absolute',
              right: '0.5rem',
              top: '50%',
              transform: 'translateY(-50%)',
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              fontSize: '1.2rem',
              padding: 0,
              lineHeight: 1,
              color: '#666'
            }}
            aria-label="Jelszó megjelenítése/elrejtése"
          >
            {showPassword ? <FiEyeOff /> : <FiEye />}
          </button>
        </div>

        <button
          type="submit"
          disabled={loading}
          style={{
            backgroundColor: '#b30000',
            color: 'white',
            padding: '0.5rem',
            fontWeight: 'bold',
            border: 'none',
            borderRadius: '5px',
            cursor: loading ? 'not-allowed' : 'pointer',
            opacity: loading ? 0.6 : 1
          }}
        >
          {loading ? 'Bejelentkezés...' : 'Bejelentkezés'}
        </button>

        {error && (
          <div style={{ color: 'red', fontSize: '0.9rem', textAlign: 'center' }}>
            {error}
          </div>
        )}
        {isLoggedIn && (
          <div style={{ color: 'green', fontSize: '0.9rem', textAlign: 'center' }}>
            ✅ Sikeres bejelentkezés!
          </div>
        )}
      </form>

      <div style={{ marginTop: '1rem', textAlign: 'center', fontSize: '0.9rem' }}>
        <Link to="/jelszovisszaallitas" style={{ marginRight: '1rem' }}>
          Elfelejtetted a jelszavad?
        </Link>
        <Link to="/regisztracio">Regisztráció</Link>
      </div>

      {onClose && (
        <div style={{ marginTop: '1rem', textAlign: 'center' }}>
          <button
            onClick={onClose}
            style={{
              backgroundColor: '#eee',
              color: '#333',
              padding: '0.3rem 0.6rem',
              borderRadius: '4px',
              border: 'none',
              cursor: 'pointer',
              fontSize: '0.8rem'
            }}
          >
            Bezárás
          </button>
        </div>
      )}
    </div>
  );
};

export default LoginForm;
